export default __webpack_public_path__ + "static/media/AR-1.29f93832.jpg";